// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VistoriasRouteImport } from './routes/vistorias'
import { Route as VistoriaRouteImport } from './routes/vistoria'
import { Route as VendasRouteImport } from './routes/vendas'
import { Route as VehiclesRouteImport } from './routes/vehicles'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TecnicoRouteImport } from './routes/tecnico'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InicioRouteImport } from './routes/inicio'
import { Route as GroupsRouteImport } from './routes/groups'
import { Route as GeofencesRouteImport } from './routes/geofences'
import { Route as FrotaRouteImport } from './routes/frota'
import { Route as FinanceiroRouteImport } from './routes/financeiro'
import { Route as DriversRouteImport } from './routes/drivers'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ConsultasRouteImport } from './routes/consultas'
import { Route as CameraRouteImport } from './routes/camera'
import { Route as AssistenciaRouteImport } from './routes/assistencia'
import { Route as ApresentacaoRouteImport } from './routes/apresentacao'
import { Route as AlertsRouteImport } from './routes/alerts'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MasterIndexRouteImport } from './routes/master.index'
import { Route as AgendaIndexRouteImport } from './routes/agenda.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as MasterVehicleLinkRouteImport } from './routes/master.vehicle-link'
import { Route as MasterVehicleFillRouteImport } from './routes/master.vehicle-fill'
import { Route as MasterTrackerProtocolsRouteImport } from './routes/master.tracker-protocols'
import { Route as MasterSmsRouteImport } from './routes/master.sms'
import { Route as MasterServerRouteImport } from './routes/master.server'
import { Route as MasterNotificationsRouteImport } from './routes/master.notifications'
import { Route as MasterMigrationRouteImport } from './routes/master.migration'
import { Route as MasterLoginRouteImport } from './routes/master.login'
import { Route as MasterIntegrationsRouteImport } from './routes/master.integrations'
import { Route as MasterIconModelsRouteImport } from './routes/master.icon-models'
import { Route as MasterAppRouteImport } from './routes/master.app'
import { Route as IndicacaoCodeRouteImport } from './routes/indicacao.$code'
import { Route as GuinchoTokenRouteImport } from './routes/guincho.$token'
import { Route as FSlugRouteImport } from './routes/f.$slug'
import { Route as DevGoogleDeckglMapRouteImport } from './routes/dev.google-deckgl-map'
import { Route as AoVivoTokenRouteImport } from './routes/ao-vivo.$token'
import { Route as AgendaParametroRouteImport } from './routes/agenda.parametro'
import { Route as AgendaLogsRouteImport } from './routes/agenda.logs'
import { Route as AgendaLinhasSmsRouteImport } from './routes/agenda.linhas-sms'
import { Route as AgendaGestaoChipsRouteImport } from './routes/agenda.gestao-chips'
import { Route as AgendaEstoqueRouteImport } from './routes/agenda.estoque'
import { Route as AgendaConfiguracoesRouteImport } from './routes/agenda.configuracoes'
import { Route as AgendaChamadosRouteImport } from './routes/agenda.chamados'
import { Route as AgendaAtendimentosRouteImport } from './routes/agenda.atendimentos'
import { Route as AgendaAgendamentosRouteImport } from './routes/agenda.agendamentos'
import { Route as AdminWebhooksRouteImport } from './routes/admin.webhooks'
import { Route as AdminTechnicianTestPasswordRouteImport } from './routes/admin.technician-test-password'
import { Route as AdminPowerCutAlertRouteImport } from './routes/admin.power-cut-alert'
import { Route as AdminPlansRouteImport } from './routes/admin.plans'
import { Route as AdminNotificationsRouteImport } from './routes/admin.notifications'
import { Route as AdminInvoiceWhatsappRouteImport } from './routes/admin.invoice-whatsapp'
import { Route as AdminIntegrationsRouteImport } from './routes/admin.integrations'
import { Route as AdminIdentityRouteImport } from './routes/admin.identity'
import { Route as AdminGt06CommandsRouteImport } from './routes/admin.gt06-commands'
import { Route as AdminFleetManagementRouteImport } from './routes/admin.fleet-management'
import { Route as AdminContractRouteImport } from './routes/admin.contract'
import { Route as AdminCommunicationFailureRouteImport } from './routes/admin.communication-failure'
import { Route as AdminCommunicationRouteImport } from './routes/admin.communication'
import { Route as AdminAssistanceRouteImport } from './routes/admin.assistance'
import { Route as AdminAiAssistantRouteImport } from './routes/admin.ai-assistant'
import { Route as AdminAgendaMessagesRouteImport } from './routes/admin.agenda-messages'
import { Route as AcompanharTokenRouteImport } from './routes/acompanhar.$token'
import { Route as AdminFormsIndexRouteImport } from './routes/admin.forms.index'
import { Route as MasterCameraImeiRouteImport } from './routes/master.camera.$imei'
import { Route as ContratoAssinarTokenRouteImport } from './routes/contrato.assinar.$token'
import { Route as AdminFormsIdRouteImport } from './routes/admin.forms.$id'
import { Route as ContratoAssinarMTokenRouteImport } from './routes/contrato.assinar.m.$token'

const VistoriasRoute = VistoriasRouteImport.update({
            id: '/vistorias',path: '/vistorias',getParentRoute: () => rootRouteImport
          })
const VistoriaRoute = VistoriaRouteImport.update({
            id: '/vistoria',path: '/vistoria',getParentRoute: () => rootRouteImport
          })
const VendasRoute = VendasRouteImport.update({
            id: '/vendas',path: '/vendas',getParentRoute: () => rootRouteImport
          })
const VehiclesRoute = VehiclesRouteImport.update({
            id: '/vehicles',path: '/vehicles',getParentRoute: () => rootRouteImport
          })
const UsersRoute = UsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => rootRouteImport
          })
const TecnicoRoute = TecnicoRouteImport.update({
            id: '/tecnico',path: '/tecnico',getParentRoute: () => rootRouteImport
          })
const ReportsRoute = ReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
            id: '/politica-de-privacidade',path: '/politica-de-privacidade',getParentRoute: () => rootRouteImport
          })
const MaintenanceRoute = MaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const InicioRoute = InicioRouteImport.update({
            id: '/inicio',path: '/inicio',getParentRoute: () => rootRouteImport
          })
const GroupsRoute = GroupsRouteImport.update({
            id: '/groups',path: '/groups',getParentRoute: () => rootRouteImport
          })
const GeofencesRoute = GeofencesRouteImport.update({
            id: '/geofences',path: '/geofences',getParentRoute: () => rootRouteImport
          })
const FrotaRoute = FrotaRouteImport.update({
            id: '/frota',path: '/frota',getParentRoute: () => rootRouteImport
          })
const FinanceiroRoute = FinanceiroRouteImport.update({
            id: '/financeiro',path: '/financeiro',getParentRoute: () => rootRouteImport
          })
const DriversRoute = DriversRouteImport.update({
            id: '/drivers',path: '/drivers',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const ConsultasRoute = ConsultasRouteImport.update({
            id: '/consultas',path: '/consultas',getParentRoute: () => rootRouteImport
          })
const CameraRoute = CameraRouteImport.update({
            id: '/camera',path: '/camera',getParentRoute: () => rootRouteImport
          })
const AssistenciaRoute = AssistenciaRouteImport.update({
            id: '/assistencia',path: '/assistencia',getParentRoute: () => rootRouteImport
          })
const ApresentacaoRoute = ApresentacaoRouteImport.update({
            id: '/apresentacao',path: '/apresentacao',getParentRoute: () => rootRouteImport
          })
const AlertsRoute = AlertsRouteImport.update({
            id: '/alerts',path: '/alerts',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const MasterIndexRoute = MasterIndexRouteImport.update({
            id: '/master/',path: '/master/',getParentRoute: () => rootRouteImport
          })
const AgendaIndexRoute = AgendaIndexRouteImport.update({
            id: '/agenda/',path: '/agenda/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const MasterVehicleLinkRoute = MasterVehicleLinkRouteImport.update({
            id: '/master/vehicle-link',path: '/master/vehicle-link',getParentRoute: () => rootRouteImport
          })
const MasterVehicleFillRoute = MasterVehicleFillRouteImport.update({
            id: '/master/vehicle-fill',path: '/master/vehicle-fill',getParentRoute: () => rootRouteImport
          })
const MasterTrackerProtocolsRoute = MasterTrackerProtocolsRouteImport.update({
            id: '/master/tracker-protocols',path: '/master/tracker-protocols',getParentRoute: () => rootRouteImport
          })
const MasterSmsRoute = MasterSmsRouteImport.update({
            id: '/master/sms',path: '/master/sms',getParentRoute: () => rootRouteImport
          })
const MasterServerRoute = MasterServerRouteImport.update({
            id: '/master/server',path: '/master/server',getParentRoute: () => rootRouteImport
          })
const MasterNotificationsRoute = MasterNotificationsRouteImport.update({
            id: '/master/notifications',path: '/master/notifications',getParentRoute: () => rootRouteImport
          })
const MasterMigrationRoute = MasterMigrationRouteImport.update({
            id: '/master/migration',path: '/master/migration',getParentRoute: () => rootRouteImport
          })
const MasterLoginRoute = MasterLoginRouteImport.update({
            id: '/master/login',path: '/master/login',getParentRoute: () => rootRouteImport
          })
const MasterIntegrationsRoute = MasterIntegrationsRouteImport.update({
            id: '/master/integrations',path: '/master/integrations',getParentRoute: () => rootRouteImport
          })
const MasterIconModelsRoute = MasterIconModelsRouteImport.update({
            id: '/master/icon-models',path: '/master/icon-models',getParentRoute: () => rootRouteImport
          })
const MasterAppRoute = MasterAppRouteImport.update({
            id: '/master/app',path: '/master/app',getParentRoute: () => rootRouteImport
          })
const IndicacaoCodeRoute = IndicacaoCodeRouteImport.update({
            id: '/indicacao/$code',path: '/indicacao/$code',getParentRoute: () => rootRouteImport
          })
const GuinchoTokenRoute = GuinchoTokenRouteImport.update({
            id: '/guincho/$token',path: '/guincho/$token',getParentRoute: () => rootRouteImport
          })
const FSlugRoute = FSlugRouteImport.update({
            id: '/f/$slug',path: '/f/$slug',getParentRoute: () => rootRouteImport
          })
const DevGoogleDeckglMapRoute = DevGoogleDeckglMapRouteImport.update({
            id: '/dev/google-deckgl-map',path: '/dev/google-deckgl-map',getParentRoute: () => rootRouteImport
          })
const AoVivoTokenRoute = AoVivoTokenRouteImport.update({
            id: '/ao-vivo/$token',path: '/ao-vivo/$token',getParentRoute: () => rootRouteImport
          })
const AgendaParametroRoute = AgendaParametroRouteImport.update({
            id: '/agenda/parametro',path: '/agenda/parametro',getParentRoute: () => rootRouteImport
          })
const AgendaLogsRoute = AgendaLogsRouteImport.update({
            id: '/agenda/logs',path: '/agenda/logs',getParentRoute: () => rootRouteImport
          })
const AgendaLinhasSmsRoute = AgendaLinhasSmsRouteImport.update({
            id: '/agenda/linhas-sms',path: '/agenda/linhas-sms',getParentRoute: () => rootRouteImport
          })
const AgendaGestaoChipsRoute = AgendaGestaoChipsRouteImport.update({
            id: '/agenda/gestao-chips',path: '/agenda/gestao-chips',getParentRoute: () => rootRouteImport
          })
const AgendaEstoqueRoute = AgendaEstoqueRouteImport.update({
            id: '/agenda/estoque',path: '/agenda/estoque',getParentRoute: () => rootRouteImport
          })
const AgendaConfiguracoesRoute = AgendaConfiguracoesRouteImport.update({
            id: '/agenda/configuracoes',path: '/agenda/configuracoes',getParentRoute: () => rootRouteImport
          })
const AgendaChamadosRoute = AgendaChamadosRouteImport.update({
            id: '/agenda/chamados',path: '/agenda/chamados',getParentRoute: () => rootRouteImport
          })
const AgendaAtendimentosRoute = AgendaAtendimentosRouteImport.update({
            id: '/agenda/atendimentos',path: '/agenda/atendimentos',getParentRoute: () => rootRouteImport
          })
const AgendaAgendamentosRoute = AgendaAgendamentosRouteImport.update({
            id: '/agenda/agendamentos',path: '/agenda/agendamentos',getParentRoute: () => rootRouteImport
          })
const AdminWebhooksRoute = AdminWebhooksRouteImport.update({
            id: '/admin/webhooks',path: '/admin/webhooks',getParentRoute: () => rootRouteImport
          })
const AdminTechnicianTestPasswordRoute = AdminTechnicianTestPasswordRouteImport.update({
            id: '/admin/technician-test-password',path: '/admin/technician-test-password',getParentRoute: () => rootRouteImport
          })
const AdminPowerCutAlertRoute = AdminPowerCutAlertRouteImport.update({
            id: '/admin/power-cut-alert',path: '/admin/power-cut-alert',getParentRoute: () => rootRouteImport
          })
const AdminPlansRoute = AdminPlansRouteImport.update({
            id: '/admin/plans',path: '/admin/plans',getParentRoute: () => rootRouteImport
          })
const AdminNotificationsRoute = AdminNotificationsRouteImport.update({
            id: '/admin/notifications',path: '/admin/notifications',getParentRoute: () => rootRouteImport
          })
const AdminInvoiceWhatsappRoute = AdminInvoiceWhatsappRouteImport.update({
            id: '/admin/invoice-whatsapp',path: '/admin/invoice-whatsapp',getParentRoute: () => rootRouteImport
          })
const AdminIntegrationsRoute = AdminIntegrationsRouteImport.update({
            id: '/admin/integrations',path: '/admin/integrations',getParentRoute: () => rootRouteImport
          })
const AdminIdentityRoute = AdminIdentityRouteImport.update({
            id: '/admin/identity',path: '/admin/identity',getParentRoute: () => rootRouteImport
          })
const AdminGt06CommandsRoute = AdminGt06CommandsRouteImport.update({
            id: '/admin/gt06-commands',path: '/admin/gt06-commands',getParentRoute: () => rootRouteImport
          })
const AdminFleetManagementRoute = AdminFleetManagementRouteImport.update({
            id: '/admin/fleet-management',path: '/admin/fleet-management',getParentRoute: () => rootRouteImport
          })
const AdminContractRoute = AdminContractRouteImport.update({
            id: '/admin/contract',path: '/admin/contract',getParentRoute: () => rootRouteImport
          })
const AdminCommunicationFailureRoute = AdminCommunicationFailureRouteImport.update({
            id: '/admin/communication-failure',path: '/admin/communication-failure',getParentRoute: () => rootRouteImport
          })
const AdminCommunicationRoute = AdminCommunicationRouteImport.update({
            id: '/admin/communication',path: '/admin/communication',getParentRoute: () => rootRouteImport
          })
const AdminAssistanceRoute = AdminAssistanceRouteImport.update({
            id: '/admin/assistance',path: '/admin/assistance',getParentRoute: () => rootRouteImport
          })
const AdminAiAssistantRoute = AdminAiAssistantRouteImport.update({
            id: '/admin/ai-assistant',path: '/admin/ai-assistant',getParentRoute: () => rootRouteImport
          })
const AdminAgendaMessagesRoute = AdminAgendaMessagesRouteImport.update({
            id: '/admin/agenda-messages',path: '/admin/agenda-messages',getParentRoute: () => rootRouteImport
          })
const AcompanharTokenRoute = AcompanharTokenRouteImport.update({
            id: '/acompanhar/$token',path: '/acompanhar/$token',getParentRoute: () => rootRouteImport
          })
const AdminFormsIndexRoute = AdminFormsIndexRouteImport.update({
            id: '/admin/forms/',path: '/admin/forms/',getParentRoute: () => rootRouteImport
          })
const MasterCameraImeiRoute = MasterCameraImeiRouteImport.update({
            id: '/master/camera/$imei',path: '/master/camera/$imei',getParentRoute: () => rootRouteImport
          })
const ContratoAssinarTokenRoute = ContratoAssinarTokenRouteImport.update({
            id: '/contrato/assinar/$token',path: '/contrato/assinar/$token',getParentRoute: () => rootRouteImport
          })
const AdminFormsIdRoute = AdminFormsIdRouteImport.update({
            id: '/admin/forms/$id',path: '/admin/forms/$id',getParentRoute: () => rootRouteImport
          })
const ContratoAssinarMTokenRoute = ContratoAssinarMTokenRouteImport.update({
            id: '/contrato/assinar/m/$token',path: '/contrato/assinar/m/$token',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AlertsRoute: AlertsRoute,ApresentacaoRoute: ApresentacaoRoute,AssistenciaRoute: AssistenciaRoute,CameraRoute: CameraRoute,ConsultasRoute: ConsultasRoute,DashboardRoute: DashboardRoute,DriversRoute: DriversRoute,FinanceiroRoute: FinanceiroRoute,FrotaRoute: FrotaRoute,GeofencesRoute: GeofencesRoute,GroupsRoute: GroupsRoute,InicioRoute: InicioRoute,LoginRoute: LoginRoute,MaintenanceRoute: MaintenanceRoute,PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,PrivacidadeRoute: PrivacidadeRoute,ReportsRoute: ReportsRoute,TecnicoRoute: TecnicoRoute,UsersRoute: UsersRoute,VehiclesRoute: VehiclesRoute,VendasRoute: VendasRoute,VistoriaRoute: VistoriaRoute,VistoriasRoute: VistoriasRoute,AcompanharTokenRoute: AcompanharTokenRoute,AdminAgendaMessagesRoute: AdminAgendaMessagesRoute,AdminAiAssistantRoute: AdminAiAssistantRoute,AdminAssistanceRoute: AdminAssistanceRoute,AdminCommunicationRoute: AdminCommunicationRoute,AdminCommunicationFailureRoute: AdminCommunicationFailureRoute,AdminContractRoute: AdminContractRoute,AdminFleetManagementRoute: AdminFleetManagementRoute,AdminGt06CommandsRoute: AdminGt06CommandsRoute,AdminIdentityRoute: AdminIdentityRoute,AdminIntegrationsRoute: AdminIntegrationsRoute,AdminInvoiceWhatsappRoute: AdminInvoiceWhatsappRoute,AdminNotificationsRoute: AdminNotificationsRoute,AdminPlansRoute: AdminPlansRoute,AdminPowerCutAlertRoute: AdminPowerCutAlertRoute,AdminTechnicianTestPasswordRoute: AdminTechnicianTestPasswordRoute,AdminWebhooksRoute: AdminWebhooksRoute,AgendaAgendamentosRoute: AgendaAgendamentosRoute,AgendaAtendimentosRoute: AgendaAtendimentosRoute,AgendaChamadosRoute: AgendaChamadosRoute,AgendaConfiguracoesRoute: AgendaConfiguracoesRoute,AgendaEstoqueRoute: AgendaEstoqueRoute,AgendaGestaoChipsRoute: AgendaGestaoChipsRoute,AgendaLinhasSmsRoute: AgendaLinhasSmsRoute,AgendaLogsRoute: AgendaLogsRoute,AgendaParametroRoute: AgendaParametroRoute,AoVivoTokenRoute: AoVivoTokenRoute,DevGoogleDeckglMapRoute: DevGoogleDeckglMapRoute,FSlugRoute: FSlugRoute,GuinchoTokenRoute: GuinchoTokenRoute,IndicacaoCodeRoute: IndicacaoCodeRoute,MasterAppRoute: MasterAppRoute,MasterIconModelsRoute: MasterIconModelsRoute,MasterIntegrationsRoute: MasterIntegrationsRoute,MasterLoginRoute: MasterLoginRoute,MasterMigrationRoute: MasterMigrationRoute,MasterNotificationsRoute: MasterNotificationsRoute,MasterServerRoute: MasterServerRoute,MasterSmsRoute: MasterSmsRoute,MasterTrackerProtocolsRoute: MasterTrackerProtocolsRoute,MasterVehicleFillRoute: MasterVehicleFillRoute,MasterVehicleLinkRoute: MasterVehicleLinkRoute,AdminIndexRoute: AdminIndexRoute,AgendaIndexRoute: AgendaIndexRoute,MasterIndexRoute: MasterIndexRoute,AdminFormsIdRoute: AdminFormsIdRoute,ContratoAssinarTokenRoute: ContratoAssinarTokenRoute,MasterCameraImeiRoute: MasterCameraImeiRoute,AdminFormsIndexRoute: AdminFormsIndexRoute,ContratoAssinarMTokenRoute: ContratoAssinarMTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)